import firstParaAssessmentLoaderImg from "../assets/first-assessment-loader.svg";
import secondParaAssessmentLoaderImg from "../assets/second-assessment-loader.svg";
import thirdParaAssessmentLoaderImg from "../assets/third-assessment-loader.svg";
import proceedToSecondParaImg from "../assets/proceed_to_second_para_img.svg";
import proceedToThirdParaImg from "../assets/proceed_to_third_para_img.svg";
import resultReadyImg from "../assets/result_ready_img.svg";

const ASSESSMENT_STEP_VISUALS = {
  1: {
    loadingHero: firstParaAssessmentLoaderImg,
    audioSaveSuccess: proceedToSecondParaImg,
  },
  2: {
    loadingHero: secondParaAssessmentLoaderImg,
    audioSaveSuccess: proceedToThirdParaImg,
  },
  3: {
    loadingHero: thirdParaAssessmentLoaderImg,
    audioSaveSuccess: resultReadyImg,
  },
};

const fallback = ASSESSMENT_STEP_VISUALS[1];

export function getAssessmentLoadingHeroImage(step) {
  return ASSESSMENT_STEP_VISUALS[step]?.loadingHero ?? fallback.loadingHero;
}

export function getAudioSaveSuccessDialogImage(step) {
  return ASSESSMENT_STEP_VISUALS[step]?.audioSaveSuccess ?? fallback.audioSaveSuccess;
}
